import { FormLabel, Grid, TextField, Typography } from "@mui/material";
import { useProyecto } from "../../../data/ProyectoContext";
import { useActividadesContext } from "../../UmmIACategories/Hook/useActividades";

const AccionRequerida = () => {
  const { proyecto, setProyecto } = useProyecto();
  const { setPromptData, promptData } = useActividadesContext();

  const handleAccionRequerida = (event) => {
    const { value } = event.target;
    setProyecto({ ...proyecto, accion_requerida: value });
    setPromptData((prevData) => ({
      ...prevData,
      accion_requerida: value,
    }));
  };


  return (
    <Grid xs={12} lg={12} md={12}>
      <Typography
        id="modal-modal-title"
        sx={{
          fontFamily: "montserrat",
          fontSize: "1.25rem",
          fontWeight: "bold",
          color: "#336B87",
        }}
      >
        {" "}
        Acción Requerida *
      </Typography>
      <FormLabel sx={{ fontFamily: "montserrat", fontSize: "0.85rem" }}>
        {" "}
        Describe el objetivo de tu mensaje
      </FormLabel>
      <TextField
        required
        id="contexto"
        placeholder="Escribe aquí la acción requerida. Ejemplo: Traer comida para compartir a la reunión de fin de año"
        name="contexto"
        fullWidth
        autoComplete="given-name"
        variant="outlined"
        value={promptData.accion_requerida}
        onChange={handleAccionRequerida}
        InputProps={{
          sx: {
            borderRadius: 2,
            mt: 1,
            mb: 3,
            fontFamily: "montserrat",
            fontSize: "0.75rem",
            color: "#005559",
            "&::placeholder": {
              color: "#005559",
            },
            "&:before": {
              borderBottomColor: "#005559",
            },
            "&:after": {
              borderBottomColor: "#005559",
            },
          },
        }}
      />
    </Grid>
  );
};

export default AccionRequerida;
